import React from "react";

import { faThumbTack } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useIntl } from "react-intl";

import { Resource } from "@mapmycustomers/shared/types/entity";
import { Collapse, CollapsePanel } from "@mapmycustomers/ui";

import ResourceItem from "./ResourceItem";
import styles from "./ResourcesSelectModal.module.scss";

interface PinnedResourcesProps {
  multiselect: boolean;
  onChangeSelect: (resource: Resource) => void;
  pinnedResources: Resource[];
  selectedResources: Resource[];
}

const PinnedResources = ({
  multiselect,
  onChangeSelect,
  pinnedResources,
  selectedResources,
}: PinnedResourcesProps) => {
  const intl = useIntl();

  if (!pinnedResources.length) {
    return null;
  }

  return (
    <>
      <Collapse className={styles.collapse} ghost>
        <CollapsePanel
          header={
            <div className={styles.pinnedTitle}>
              <FontAwesomeIcon icon={faThumbTack} />
              <span>
                {intl.formatMessage(
                  {
                    id: "component.resourcesSelectModal.pinned",
                    defaultMessage: "Pinned ({count})",
                    description: "Pinned resources label",
                  },
                  { count: pinnedResources.length }
                )}
              </span>
            </div>
          }
          key="pinned"
        >
          <div className={styles.list}>
            {pinnedResources?.map((resource) => (
              <ResourceItem
                key={resource.id}
                multiselect={multiselect}
                onChangeSelect={onChangeSelect}
                resource={resource}
                selectedResources={selectedResources}
              />
            ))}
          </div>
        </CollapsePanel>
      </Collapse>

      <span className={styles.allResources}>
        {intl.formatMessage({
          id: "component.resourcesSelectModal.allResources",
          defaultMessage: "All Resources",
          description: "All Resources label",
        })}
      </span>
    </>
  );
};

export default PinnedResources;
